export const isEmailFormatValid = (email: string): boolean => {
  return /^[-_+.a-z0-9]+@([-a-z0-9]+\.)+[a-z]{2,}$/.test(email);
};

export const isCharacterTypeValid = (val: string): boolean => {
  let count = 0;

  // 記号を使用しているか
  if (/[!"#$%&'()*+\-.,/:;<=>?@[\\\]^_`{|}~]/.test(val)) count += 1;
  // 半角英字の大文字を使用しているか
  if (/[A-Z]/.test(val)) count += 1;
  // 半角英字の小文字を使用しているか
  if (/[a-z]/.test(val)) count += 1;
  // 半角数字を使用しているか
  if (/[0-9]/.test(val)) count += 1;

  // 文字種が2種類以上かつスペースを除く半角英数字記号のみか
  return count >= 2 && /^[\x21-\x7e]+$/.test(val);
};
